/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonaleRapportinoDTO } from './PersonaleRapportinoDTO';
import {
    PersonaleRapportinoDTOFromJSON,
    PersonaleRapportinoDTOFromJSONTyped,
    PersonaleRapportinoDTOToJSON,
    PersonaleRapportinoDTOToJSONTyped,
} from './PersonaleRapportinoDTO';

/**
 * 
 * @export
 * @interface RapportiniDTO
 */
export interface RapportiniDTO {
    /**
     * 
     * @type {number}
     * @memberof RapportiniDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportiniDTO
     */
    idCommessa?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    commessa?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RapportiniDTO
     */
    idCliente?: number;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    codiceCliente?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    cliente?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    tipoRapportino?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniDTO
     */
    dataRapportino?: Date;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    descrizioneAttivita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    ubicazioneTest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    descrizioneLavori?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    strumentiMisura?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isRelazioneProva?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isSchedaTecnica?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    riferimentoOrdine?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    luogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    personaRiferimento?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isTrimestrale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isSemestrale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isAnnuale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isManutenzioneStraordinaria?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isControlliNonDistruttivi?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniDTO
     */
    dataRiferimentoOrdine?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    riferimentoDDT?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniDTO
     */
    dataRiferimentoDDT?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniDTO
     */
    attrezzatureSpeciali?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isCheckList?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isReportAnomalie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniDTO
     */
    isReportIntervento?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniDTO
     */
    dataFirma?: Date | null;
    /**
     * 
     * @type {Array<PersonaleRapportinoDTO>}
     * @memberof RapportiniDTO
     */
    personaleRapportino?: Array<PersonaleRapportinoDTO> | null;
}

/**
 * Check if a given object implements the RapportiniDTO interface.
 */
export function instanceOfRapportiniDTO(value: object): value is RapportiniDTO {
    return true;
}

export function RapportiniDTOFromJSON(json: any): RapportiniDTO {
    return RapportiniDTOFromJSONTyped(json, false);
}

export function RapportiniDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportiniDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'idCommessa': json['idCommessa'] == null ? undefined : json['idCommessa'],
        'commessa': json['commessa'] == null ? undefined : json['commessa'],
        'idCliente': json['idCliente'] == null ? undefined : json['idCliente'],
        'codiceCliente': json['codiceCliente'] == null ? undefined : json['codiceCliente'],
        'cliente': json['cliente'] == null ? undefined : json['cliente'],
        'tipoRapportino': json['tipoRapportino'] == null ? undefined : json['tipoRapportino'],
        'dataRapportino': json['dataRapportino'] == null ? undefined : (new Date(json['dataRapportino'])),
        'descrizioneAttivita': json['descrizioneAttivita'] == null ? undefined : json['descrizioneAttivita'],
        'ubicazioneTest': json['ubicazioneTest'] == null ? undefined : json['ubicazioneTest'],
        'descrizioneLavori': json['descrizioneLavori'] == null ? undefined : json['descrizioneLavori'],
        'strumentiMisura': json['strumentiMisura'] == null ? undefined : json['strumentiMisura'],
        'isRelazioneProva': json['isRelazioneProva'] == null ? undefined : json['isRelazioneProva'],
        'isSchedaTecnica': json['isSchedaTecnica'] == null ? undefined : json['isSchedaTecnica'],
        'riferimentoOrdine': json['riferimentoOrdine'] == null ? undefined : json['riferimentoOrdine'],
        'luogo': json['luogo'] == null ? undefined : json['luogo'],
        'personaRiferimento': json['personaRiferimento'] == null ? undefined : json['personaRiferimento'],
        'isTrimestrale': json['isTrimestrale'] == null ? undefined : json['isTrimestrale'],
        'isSemestrale': json['isSemestrale'] == null ? undefined : json['isSemestrale'],
        'isAnnuale': json['isAnnuale'] == null ? undefined : json['isAnnuale'],
        'isManutenzioneStraordinaria': json['isManutenzioneStraordinaria'] == null ? undefined : json['isManutenzioneStraordinaria'],
        'isControlliNonDistruttivi': json['isControlliNonDistruttivi'] == null ? undefined : json['isControlliNonDistruttivi'],
        'dataRiferimentoOrdine': json['dataRiferimentoOrdine'] == null ? undefined : (new Date(json['dataRiferimentoOrdine'])),
        'riferimentoDDT': json['riferimentoDDT'] == null ? undefined : json['riferimentoDDT'],
        'dataRiferimentoDDT': json['dataRiferimentoDDT'] == null ? undefined : (new Date(json['dataRiferimentoDDT'])),
        'attrezzatureSpeciali': json['attrezzatureSpeciali'] == null ? undefined : json['attrezzatureSpeciali'],
        'isCheckList': json['isCheckList'] == null ? undefined : json['isCheckList'],
        'isReportAnomalie': json['isReportAnomalie'] == null ? undefined : json['isReportAnomalie'],
        'isReportIntervento': json['isReportIntervento'] == null ? undefined : json['isReportIntervento'],
        'dataFirma': json['dataFirma'] == null ? undefined : (new Date(json['dataFirma'])),
        'personaleRapportino': json['personaleRapportino'] == null ? undefined : ((json['personaleRapportino'] as Array<any>).map(PersonaleRapportinoDTOFromJSON)),
    };
}

export function RapportiniDTOToJSON(json: any): RapportiniDTO {
    return RapportiniDTOToJSONTyped(json, false);
}

export function RapportiniDTOToJSONTyped(value?: RapportiniDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'idCommessa': value['idCommessa'],
        'commessa': value['commessa'],
        'idCliente': value['idCliente'],
        'codiceCliente': value['codiceCliente'],
        'cliente': value['cliente'],
        'tipoRapportino': value['tipoRapportino'],
        'dataRapportino': value['dataRapportino'] == null ? undefined : ((value['dataRapportino']).toISOString()),
        'descrizioneAttivita': value['descrizioneAttivita'],
        'ubicazioneTest': value['ubicazioneTest'],
        'descrizioneLavori': value['descrizioneLavori'],
        'strumentiMisura': value['strumentiMisura'],
        'isRelazioneProva': value['isRelazioneProva'],
        'isSchedaTecnica': value['isSchedaTecnica'],
        'riferimentoOrdine': value['riferimentoOrdine'],
        'luogo': value['luogo'],
        'personaRiferimento': value['personaRiferimento'],
        'isTrimestrale': value['isTrimestrale'],
        'isSemestrale': value['isSemestrale'],
        'isAnnuale': value['isAnnuale'],
        'isManutenzioneStraordinaria': value['isManutenzioneStraordinaria'],
        'isControlliNonDistruttivi': value['isControlliNonDistruttivi'],
        'dataRiferimentoOrdine': value['dataRiferimentoOrdine'] == null ? undefined : ((value['dataRiferimentoOrdine'] as any).toISOString()),
        'riferimentoDDT': value['riferimentoDDT'],
        'dataRiferimentoDDT': value['dataRiferimentoDDT'] == null ? undefined : ((value['dataRiferimentoDDT'] as any).toISOString()),
        'attrezzatureSpeciali': value['attrezzatureSpeciali'],
        'isCheckList': value['isCheckList'],
        'isReportAnomalie': value['isReportAnomalie'],
        'isReportIntervento': value['isReportIntervento'],
        'dataFirma': value['dataFirma'] == null ? undefined : ((value['dataFirma'] as any).toISOString()),
        'personaleRapportino': value['personaleRapportino'] == null ? undefined : ((value['personaleRapportino'] as Array<any>).map(PersonaleRapportinoDTOToJSON)),
    };
}

